import React from 'react';
import AccessDenied from 'components/AccessDenied';
import s from './s.module.less';

const AccessDeniedPage = () => {
    return <div className={s.wrap}><AccessDenied /></div>;
};

export default AccessDeniedPage;
